var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.333 1.333V0H10v1.333h3.333v1.334H12v10a.667.667 0 0 1-.667.666H2a.667.667 0 0 1-.667-.666v-10H0V1.333h3.333Zm-.666 1.334V12h8V2.667h-8Zm2 2H6V10H4.667V4.667Zm2.666 0h1.334V10H7.333V4.667Z",
  fill: "currentColor"
})));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "static/media/e9b5b6ba.svg";